import { DatePipe, CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UtilityService } from 'src/app/_helpers/utility.service';
import { operations } from 'src/app/_model/constants';
import { FileNameData } from 'src/app/_model/FileNameData';
import { HrAdminOvertimeRequest } from 'src/app/_model/request/HrAdminOvertimeRequest';
import { Overtime } from 'src/app/_model/overtime';
import { OvertimeDeservedDto } from 'src/app/_model/OvertimeDeservedDto';
import { OvertimeLookup } from 'src/app/_model/OvertimeLookup';
import { ListDocumentRequest } from 'src/app/_model/request/ListDocumentRequest';
import { OvertimeDeservedRequest } from 'src/app/_model/request/OvertimeDeservedRequest';
import { OvertimeRequest } from 'src/app/_model/request/OvertimeRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { EmployeeService } from 'src/app/_services/employee.service';
import { LookupService } from 'src/app/_services/lookup.service';
import { OvertimeService } from 'src/app/_services/overtime.service';
import { StorageService } from 'src/app/_services/storage.service';
import { AppConstants, DIALOG_OPERATIONS, PROCESS } from 'src/app/_utils/constants';
import { environment } from 'src/environments/environment';
import { DialogCloseData } from 'src/app/_model/models';
import * as $ from 'jquery';
import { MaterialModule } from 'src/app/material.module';
import { MatRadioButton } from '@angular/material/radio';

@Component({
    selector: 'app-overtime-update',
    templateUrl: './overtime-update.component.html',
    styleUrls: ['./overtime-update.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MaterialModule,
        MatRadioButton
    ]
})
export class OvertimeUpdateComponent implements OnInit {

    @ViewChild('myFile', { static: true }) myFileVariable: ElementRef;
    overtimeRequest: OvertimeRequest;
    submitButtonName = 'Kaydet';
    operationName: string;
    submitted = false;
    currentUser = new User();
    overtimeTypeList: OvertimeLookup[];
    overtimeBranchList: OvertimeLookup[];
    overtimeProjectList: OvertimeLookup[];
    overtimeTenantList: OvertimeLookup[];
    selectedOvertimeType: OvertimeLookup = new OvertimeLookup();
    selectedOvertimeBranch: OvertimeLookup = new OvertimeLookup();
    selectedOvertimeProject: OvertimeLookup = new OvertimeLookup();
    selectedOvertimeTenant: OvertimeLookup = new OvertimeLookup();
    fileList: FileNameData[] = [];
    // file upload variables
    fileData: File = null;
    fileUploadProgress: string = null;
    fileUploadRoot = environment.fileUploadPath;
    isOvertimeExcuseSelected = false;
    isOvertimeOwnerManager: boolean;

    managerList: any[];
    filteredManagerList: Observable<any[]>;

    // overtime deserved variables
    isOvertimeDeservedExist = false;
    overtimeDeservedResponse: OvertimeDeservedDto = new OvertimeDeservedDto();
    overtimeDeservedRequest: OvertimeDeservedRequest = new OvertimeDeservedRequest();

    overtimeForm: FormGroup = this.formBuilder.group({
        overtimeType: ['', [Validators.required]],
        overtimeBranch: ['', [Validators.required]],
        overtimeProject: ['', [Validators.required]],
        overtimeTenant: [''],
        overtimeDate: ['', [Validators.required]],
        overtimeDuration: [''],
        description: ['', Validators.maxLength(500)],
        filePath: [''],
        readAndAprroved: [''],
        isRestDay: [''],
    });

    bsConfig: Partial<BsDatepickerConfig>;

    // fazla mesai sartlari
    @ViewChild('conditions', { static: true })
    conditionsTemplate: TemplateRef<any>;
    conditionModalRef: BsModalRef;

    // fazla mesai kaydi baskasi adina mi kendi adina mi olusturulacak
    isOvertimeForMe = '0';
    filteredEmployeeList: Observable<any[]>;
    employees: any;
    employeeControl = new FormControl();
    personelFullname: string;
    departmentName: string;

    //hr ve admin kullanicisi fazla mesai kaydini guncellediginde iscompleted alanina mudahale etmektedir
    isCompleted = this.data.isCompleted;
    radioOnay = 1;
    radioRed = -1;
    process: number;
    selectedEmployeeId: number;

    // hour minute list
    hourMinuteListForStart: string[];
    hourMinuteListForEnd: string[];

    minuteInterval: number;
    selectedHourMinuteForStart = '';
    selectedHourMinuteForEnd = '';
    calculatedDateTimeForStart;
    calculatedDateTimeForEnd;
    invalidTimeRange = false;
    constructor(private overtimeService: OvertimeService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        public dialogRef: MatDialogRef<OvertimeUpdateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Overtime,
        private authService: AuthenticationService,
        private lookupService: LookupService,
        private datePipe: DatePipe,
        private storageService: StorageService,
        private utilityService: UtilityService,
        private employeeService: EmployeeService,
        private modalService: BsModalService) {
        this.currentUser = authService.currentUserValue;
        moment.tz.setDefault('Etc/GMT');
    }

    compareStartEndDate(overtimeDate: string, overtimeEndDate: string) {
        return (group: FormGroup) => {
            if (moment(group.get(overtimeDate).value, 'dd.MM.yyyy HH:00') >
                moment(group.get(overtimeEndDate).value, 'dd.MM.yyyy HH:00')) {
                return group.controls[overtimeEndDate].setErrors({ notEquivalent: true });
            }
        }
    }

    validateTimeRange() {
        const startTime = this.selectedHourMinuteForStart;
        const endTime = this.selectedHourMinuteForEnd;
        if (!startTime || !endTime) {
            return null;
        }
        const [startHour, startMinute] = startTime.split(':').map(Number);
        const [endHour, endMinute] = endTime.split(':').map(Number);

        if (endHour > startHour || (endHour === startHour && endMinute > startMinute))
            this.invalidTimeRange = false;
        else
            this.invalidTimeRange = true;


    }

    calculateWorkDuration(): string {
        const startTime = this.selectedHourMinuteForStart;
        const endTime = this.selectedHourMinuteForEnd;
        if (!startTime || !endTime) {
            return '';
        }
        const [startHour, startMinute] = startTime.split(':').map(Number);
        const [endHour, endMinute] = endTime.split(':').map(Number);
        const startTotalMinutes = startHour * 60 + startMinute;
        const endTotalMinutes = endHour * 60 + endMinute;
        const durationInMinutes = endTotalMinutes - startTotalMinutes;
        return (durationInMinutes / 60).toFixed(1);
    }

    ngOnInit() {
        forkJoin([
            this.lookupService.listByLookupCode('BRANCH'),
            this.lookupService.listByLookupCode('PROJECT'),
            this.lookupService.listByLookupCode('TENANT'),
            this.lookupService.listByLookupCode('OVERTIME_TYPE')
        ]).subscribe({
            next: async ([branchList, projectList, tenantList, typeList]) => {
                this.overtimeBranchList = branchList.responseData.items;
                this.overtimeProjectList = projectList.responseData.items;
                this.overtimeTenantList = tenantList.responseData.items;
                this.overtimeTypeList = typeList.responseData.items;
                if (this.data.hasOwnProperty('isNew') && this.data.isNew) {
                    this.operationName = operations.CREATE;
                    const currentStartDate = new Date();
                    this.overtimeForm.get('overtimeDate').setValue(moment(currentStartDate, AppConstants.MOMENT_DATE_FORMAT).toDate());
                    this.overtimeForm.get('overtimeType').setValue(0);
                    this.calculateDateAndHourForStart();
                    this.calculateDateAndHourForEnd();
                } else {
                    this.operationName = operations.UPDATE;

                    //saat cek

                    this.minuteInterval = this.utilityService.getMinuteInterval(this.selectedOvertimeType.overtimeTimeType);
                    this.hourMinuteListForEnd = this.utilityService.generateHourMinuteListForOvertime(this.minuteInterval);
                    this.hourMinuteListForStart = this.utilityService.generateHourMinuteList(this.minuteInterval);
                    await Promise.all([this.minuteInterval, this.hourMinuteListForEnd, this.hourMinuteListForStart]);

                    this.selectedHourMinuteForStart = this.data.startTime;
                    this.selectedHourMinuteForEnd = this.data.endTime;
                    console.log(this.data);
                    this.overtimeForm.patchValue({
                        overtimeType: this.overtimeTypeList.filter(value => value.id == this.data.overtimeTypeId)[0],
                        overtimeBranch: this.overtimeBranchList.filter(value => value.lookupValue == this.data.branchCode)[0],
                        overtimeProject: this.overtimeProjectList.filter(value => value.lookupValue == this.data.projectCode)[0],
                        overtimeTenant: this.overtimeTenantList.filter(value => value.lookupValue == this.data.tenantCode)[0],
                        overtimeDate: moment(this.data.overtimeDate, AppConstants.MOMENT_DATE_FORMAT).toDate(),
                        description: this.data.description,
                        readAndAprroved: this.data.readAndAprroved,
                        isRestDay: this.data.isRestDay,
                    });

                    this.selectedOvertimeBranch = this.overtimeBranchList.filter(value => value.lookupValue == this.data.branchCode)[0];
                    this.selectedOvertimeProject = this.overtimeProjectList.filter(value => value.lookupValue == this.data.projectCode)[0];
                    this.selectedOvertimeTenant = this.overtimeTenantList.filter(value => value.lookupValue == this.data.tenantCode)[0];
                    this.selectedOvertimeType = this.overtimeTypeList.filter(value => value.id === this.data.overtimeTypeId)[0];
                    const listDocumentRequest: ListDocumentRequest = new ListDocumentRequest('OVERTIME', this.data.id);
                    this.storageService.listDocuments(listDocumentRequest).subscribe(listResult => {
                        this.fileList = [...this.utilityService.mapPortalDocumentResponseToFileNameData(listResult.responseData.items)];
                    });
                }
                this.prepareSubmitButtonName();
            },
            error: (err) => {
                console.error('Error during service calls:', err);
            }
        });

        this.employeeService.getTopManagers().subscribe(result => {

            this.managerList = result.responseData.items.sort((a, b) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'tr'));

        });

        this.bsConfig = { dateInputFormat: 'DD.MM.YYYY HH:00', selectFromOtherMonth: true };

        this.employeeService.getEmployeeList(-1).subscribe(result => {
            this.employees = result.responseData.items.sort((a, b) =>
                a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), 'tr')
            );
            this.filteredEmployeeList = this.employeeControl.valueChanges
                .pipe(startWith(''), map(value => this.filterEmployeeList(value)));
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
        });

        this.assignPersonAndDepartmentName();

        this.employeeControl.valueChanges.subscribe(val => {
            if (val == null) {
                this.selectedEmployeeId = null;
                if (this.isOvertimeForMe === '0') {
                    this.personelFullname = this.currentUser.name + ' ' + this.currentUser.surname;
                    this.departmentName = this.currentUser.department.name;
                } else {
                    this.personelFullname = ' ';
                    this.departmentName = '';
                }
            } else {
                if (val.hasOwnProperty('id')) {
                    this.selectedEmployeeId = val.id;
                }
                if (val.hasOwnProperty('fullName')) {
                    this.personelFullname = val.fullName;
                }
                if (val.hasOwnProperty('department')) {
                    this.departmentName = val.department.description;
                }
            }
            this.setProxyManagerSettings(this.getEmployeeIdOfOvertime());
        });
    }

    setProxyManagerSettings(employeeId: number) {
        this.employeeService.getEmployeeById(employeeId).subscribe(result => {

            this.personelFullname = result.responseData.item.name + ' ' + result.responseData.item.surname;

            this.departmentName = result.responseData.item.department.lookupValue;

        });
    }

    createOrUpdateOvertime() {
        this.submitted = true;
        if (this.overtimeForm.invalid) {
            this.getFormValidationErrors();
            return;
        }

        /**
         * kayit reddedildi degil ise guncelle diyince kayit guncellenir
         * aksi halde yeni ise kaydedilir veya
         * reddedildi durumunda ise de kaydedilir
         * cunku reddedildi
         */
        if (this.process === PROCESS.UPDATE) {
            this.update();
        } else if (this.process === PROCESS.CREATE) {
            this.create();
        }
    }

    update() {
        this.calculateDateAndHourForStart();
        this.calculateDateAndHourForEnd();
        this.overtimeRequest = {
            overtimeTypeId: this.overtimeForm.get('overtimeType').value.id,
            overtimeDate: this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForStart, AppConstants.MOMENT_DATE_FORMAT),
            endTime: this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForEnd, AppConstants.MOMENT_TIME_FORMAT),
            startTime: this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForStart, AppConstants.MOMENT_TIME_FORMAT),
            description: this.overtimeForm.get('description').value,
            filePath: '',
            readAndAprroved: this.overtimeForm.get('readAndAprroved').value === 1 || this.overtimeForm.get('readAndAprroved').value === true ? 1 : 0,
            isRestDay: this.overtimeForm.get('isRestDay').value === 1 || this.overtimeForm.get('isRestDay').value === true ? 1 : 0,
            id: this.data.id,
            fileList: this.fileList,
            branchCode: this.overtimeForm.get('overtimeBranch').value.lookupValue,
            projectCode: this.overtimeForm.get('overtimeProject').value.lookupValue,
            tenantCode: this.overtimeForm.get('overtimeTenant').value ? this.overtimeForm.get('overtimeTenant').value.lookupValue : null,
            employeeId: this.getEmployeeIdOfOvertime(),
        };

        if (Number(this.calculateWorkDuration()) <= 0) return;

        if (this.data.tabNo === 5) {
            const hrAdminovertimeRequest = new HrAdminOvertimeRequest(this.overtimeRequest);
            hrAdminovertimeRequest.isCompleted = this.isCompleted;

            this.overtimeService.updateOvertimeByAdmin(hrAdminovertimeRequest).subscribe(result => {
                this.toastr.success('Güncelleme işlemi başarılı', '');
                this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE, result.responseData.item));
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        } else {
            this.overtimeService.updateOvertime(this.overtimeRequest).subscribe(result => {
                this.toastr.success('Güncelleme işlemi başarılı', '');
                this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE, result.responseData.item));
            }, error => {
                this.dialogRef.close();
            });
        }
    }

    create() {

        const validationResult = this.validateOvertimeForm();
        if (!validationResult.success) {
            this.toastr.error(validationResult.description, 'Hata');
            return;
        }
        if (Number(this.calculateWorkDuration()) <= 0) return;

        this.calculateDateAndHourForStart();
        this.calculateDateAndHourForEnd();

        this.submitButtonName = 'Kaydediliyor...';
        this.overtimeForm.disable();
        // this.overtimeRequest = this.overtimeForm.getRawValue();
        this.overtimeRequest = new OvertimeRequest(0, 0, '', 0, '', '', 0, []);
        this.overtimeRequest.description = this.overtimeForm.get('description').value;
        this.overtimeRequest.employeeId = this.getEmployeeIdOfOvertime();
        this.overtimeRequest.readAndAprroved = this.overtimeForm.get('readAndAprroved').value === true ? 1 : 0;
        this.overtimeRequest.isRestDay = this.overtimeForm.get('isRestDay').value === true ? 1 : 0;
        this.overtimeRequest.overtimeDate = this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForStart, AppConstants.MOMENT_DATE_FORMAT);
        this.overtimeRequest.endTime = this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForEnd, AppConstants.MOMENT_TIME_FORMAT);
        this.overtimeRequest.startTime = this.utilityService.converDateToStringWithFormat(this.calculatedDateTimeForStart, AppConstants.MOMENT_TIME_FORMAT);
        this.overtimeRequest.fileList = this.fileList;
        this.overtimeRequest.overtimeTypeId = this.overtimeForm.get('overtimeType').value.id;
        this.overtimeRequest.tenantCode = this.overtimeForm.get('overtimeTenant').value ? this.overtimeForm.get('overtimeTenant').value.lookupValue : null;
        this.overtimeRequest.branchCode = this.overtimeForm.get('overtimeBranch').value ? this.overtimeForm.get('overtimeBranch').value.lookupValue : null;
        this.overtimeRequest.projectCode = this.overtimeForm.get('overtimeProject').value ? this.overtimeForm.get('overtimeProject').value.lookupValue : null;

        this.overtimeService.saveOvertime(this.overtimeRequest).subscribe(saveovertimeResult => {
            this.toastr.success('Kaydedildi', 'Başarılı');
            this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.CREATE, saveovertimeResult.responseData.item));
        }, error2 => {
            this.submitButtonName = 'Kaydet';
            //this.overtimeForm.reset();
            this.overtimeForm.enable();
        }, () => {
            this.submitButtonName = 'Kaydet';
            this.overtimeForm.reset();
            this.overtimeForm.enable();
        });
    }


    fileProgress(fileInput: any) {
        this.fileData = fileInput.target.files[0];
    }

    uploadFile() {
        const formData = new FormData();
        formData.append('file', this.fileData);

        const fileType = this.fileData.name.substr(this.fileData.name.lastIndexOf('.') + 1);
        if (AppConstants.UPLOADABLE_FILE_TYPES.indexOf(fileType.toLowerCase()) < 0) {
            alert(AppConstants.UPLOADABLE_FILE_TYPES + ' dosya tiplerinden birini kullanabilirsiniz');
            this.fileData = null;
            return;
        }

        const fileSizeInMb = this.fileData.size / 1024 / 1024;
        if (fileSizeInMb >= AppConstants.FILE_UPLOAD_LIMIT) {
            alert('Dosya boyutu en fazla ' + AppConstants.FILE_UPLOAD_LIMIT + 'mb olmalıdır');
            this.myFileVariable.nativeElement.value = "";
            this.fileData = null;
            return;
        }
        const fileSizeInMbMin = this.fileData.size / 1024 / 1024;
        if (fileSizeInMbMin <= 0) {
            alert('Boş dosya yükleyemezsiniz');
            this.myFileVariable.nativeElement.value = "";
            this.fileData = null;
            return;
        }

        this.getBase64(this.fileData).then(value => {
            this.fileList.push(new FileNameData(this.fileData.name, value));
        });

        setTimeout(() => this.fileData = null, 500);
    }

    deleteFile(index: number) {
        /*
           guncelleme ekrani ise listeden ilgili kaydi tamamen ucurmak yerine willbedeleted alanini true yapip
           backendde ona gore silecegiz
         */
        if (this.operationName === operations.UPDATE) {
            this.fileList[index].willBeDeleted = true;
        } else {
            this.fileList.splice(index, 1);
        }
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    getFormValidationErrors() {
        Object.keys(this.overtimeForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.overtimeForm.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
    }

    /**
     * fazla mesai kayıt ekranında ihtiyaç duyulan form elemanlarını temizler
     */
    clearCrucialFormElements() {
        const currentStartDate = new Date();
        currentStartDate.setHours(8, 0);
        this.overtimeForm.get('overtimeDate').setValue(moment(currentStartDate, AppConstants.MOMENT_DATE_FORMAT).toDate());
    }
    startHourMinuteChanged() {
        this.calculateDateAndHourForStart();
        this.calculateWorkDuration();
        this.validateTimeRange();
    }
    endHourMinuteChanged() {
        this.calculateDateAndHourForEnd();
        this.calculateWorkDuration();
        this.validateTimeRange();
    }
    calculateDateAndHourForStart() {
        const formattedDateTimeString =
            this.datePipe.transform(this.overtimeForm.get('overtimeDate').value, 'dd.MM.yyyy') + ' ' + this.selectedHourMinuteForStart;
        this.calculatedDateTimeForStart = this.utilityService.convertStringToDateByFormat(formattedDateTimeString, AppConstants.MOMENT_DATETIME_FORMAT);
    }

    calculateDateAndHourForEnd() {
        const formattedDateTimeString =
            this.datePipe.transform(this.overtimeForm.get('overtimeDate').value, 'dd.MM.yyyy') + ' ' + this.selectedHourMinuteForEnd;
        this.calculatedDateTimeForEnd = this.utilityService.convertStringToDateByFormat(formattedDateTimeString, AppConstants.MOMENT_DATETIME_FORMAT);

    }

    closeModal() {
        this.dialogRef.close();
    }

    validateOvertimeForm(): any {
        const result = { description: '', success: true };



        if (this.fileList.length > 2) {
            result.description = 'En fazla 2 dosya yükleyebilirsiniz';
            result.success = false;
            return result;
        }


        // ik kullanicisi baskasi adina kayit olustururken calisan secmeli
        if (this.currentUser.hr && this.isOvertimeForMe === '1' && this.selectedEmployeeId == null) {
            result.description = 'Lütfen çalışan seçiniz';
            result.success = false;
            return result;
        }

        return result;
    }

    displayFn(manager: any): string | undefined {
        return manager ? manager.name + ' ' + manager.surname : undefined;
    }

    setReadonlyToHourAndMinute() {
        setTimeout(() => {
            $.default("input[formcontrolname='minute']").prop('readonly', true);
            $.default("input[formcontrolname='hour']").prop('readonly', true);
        }, 3000);
    }

    /**
     * guncelle durumunda ise ve bekliyor durumunda ise guncelle
     * guncelle durumunda ise ve reddedildi durumunda ise yenile ve kaydet
     * kaydet durumunda ise kaydet olacak
     */
    prepareSubmitButtonName() {
        if (this.data.tabNo === 5) {
            this.process = PROCESS.UPDATE;
            this.submitButtonName = 'GÜNCELLE';
        } else {
            if (this.data.isNew === false && this.data.isCompleted !== false) {
                this.process = PROCESS.UPDATE;
                this.submitButtonName = 'GÜNCELLE';
            } else if (this.data.isNew === false && this.data.isCompleted === false) {
                this.process = PROCESS.CREATE;
                this.submitButtonName = 'YENİLE VE KAYDET';
            } else {
                this.process = PROCESS.CREATE;
                this.submitButtonName = 'KAYDET';
            }
        }
    }

    clearFileListForRejected() {
        //eger reddedildi kaydi acildi ise dosyalarin attribute larini sifirla, yeni kaydedilecek gibi olsun
        this.fileList.forEach((value, index, array) => {
            array[index].willBeDeleted = false;
            array[index].alreadyStored = false;
        });
    }

    openConditionsTemplate() {
        this.conditionModalRef = this.modalService.show(this.conditionsTemplate);
    }

    private filterEmployeeList(value: any): string[] {
        let filterValue = '';
        if (value != null) {
            if (value.hasOwnProperty('fullName')) {
                filterValue = this.utilityService.toTurkishLowerCase(value.fullName);
            } else {
                filterValue = this.utilityService.toTurkishLowerCase(value);
            }
        }
        return this.employees.filter(employee =>
            this.utilityService.toTurkishLowerCase(employee.fullName).includes(filterValue));
    }

    displayFn2(employee: any): string | undefined {
                return employee ? employee.fullName : undefined;
    }

    assignPersonAndDepartmentName() {
        if (!this.data.isNew) {
            this.personelFullname = this.data.name + ' ' + this.data.surname;
            this.departmentName = this.data.departmentName;
        } else {
            if (!(this.currentUser.hr && this.isOvertimeForMe === '1')) {
                this.personelFullname = this.currentUser.name + ' ' + this.currentUser.surname;
                this.departmentName = this.currentUser.department.name;
            } else {
                this.personelFullname = '';
                this.departmentName = '';
            }
        }
    }

    overtimeTypeChanged() {
        this.minuteInterval = this.utilityService.getMinuteInterval(this.selectedOvertimeType.overtimeTimeType);
        this.hourMinuteListForEnd = this.utilityService.generateHourMinuteListForOvertime(this.minuteInterval);
        this.hourMinuteListForStart = this.utilityService.generateHourMinuteList(this.minuteInterval);
        this.selectedHourMinuteForStart = this.selectedOvertimeType.attribute5;
        this.selectedHourMinuteForEnd = this.selectedOvertimeType.attribute6;
    }

    overtimeProjectChanged() {
        this.selectedOvertimeTenant = null;
    }

    overtimeOwnerChange() {
        this.assignPersonAndDepartmentName();
        this.overtimeForm.reset();
        this.isOvertimeDeservedExist = false;
        this.isOvertimeExcuseSelected = false;
        this.employeeControl.setValue(null);
    }

    // ik baskasi adina cagri acarsa o secilen kisinin id sini atiyoruz
    getEmployeeIdOfOvertime() {
        if (this.data.isNew) { // yeni kayit
            if (this.currentUser.hr && this.isOvertimeForMe === '1') {
                return this.selectedEmployeeId != null ? this.selectedEmployeeId : this.currentUser.employeeId;
            } else {
                return this.currentUser.employeeId;
            }
        } else { // guncelleme
            if (this.selectedEmployeeId == null) {
                return this.data.employeeId;
            } else {
                return this.selectedEmployeeId;
            }
        }
    }

    overtimeDurationChanged() {

    }
}
